<template lang="pug">
	div(:class="{'edit-inline': !wrapped, 'edit-mode':editModeActive}")
		span(v-if="!notext && !r['_edit_'+field]", :class="'format-'+type") {{ r[field] }} {{ postfix }} {{ additionalText }}
		textarea.form-control.form-control-sm(v-model="r['_'+field]", v-if="r['_edit_' + field] && type==='textarea'")
		input.form-control.form-control-sm(type="text", v-model="r['_'+field]", v-if="r['_edit_' + field] && type==='input'")
		span.quickedit-buttons(v-if="!readonly")
			a.edit-button(href="javascript:void(0)", @click="editRecord(r, field)", v-if="!r['_edit_' + field]", v-b-tooltip.hover.right, title="Edit")
				i.la.la-pencil
			a(href="javascript:void(0)", @click="cancelEditRecord(r, field)", v-if="r['_edit_' + field]", v-b-tooltip.hover.bottom, title="Cancel")
				i.la.la-times
			a(href="javascript:void(0)", @click="saveRecord(r, field)", v-if="r['_edit_' + field]", v-b-tooltip.hover.bottom, title="Save Changes")
				i.la.la-save
</template>
<script>
import Vue from 'vue';

export default {
  name: 'QuickEdit',
  props: {
    notext: {
      type: Boolean,
      default() {
        return false;
      },
    },
    wrapped: Boolean,
    r: {
      type: Object,
    },
    type: {
      type: String,
      default() {
        return 'input';
      },
    },
    field: {
      type: String,
    },
    postfix: {
      type: String,
      default() {
        return '';
      },
    },
    additionalText: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    editModeActive: function () {
      return this.editMode;
    },
    readonly: function () {
      return this.r && this.r.reserved;
    },
  },
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    editRecord(r, field) {
      if (r.reserved) return;
      this.editMode = true;
      Vue.set(r, '_' + field, r[field]);
      Vue.set(r, '_edit_' + field, true);
      r = r[field];
    },
    cancelEditRecord(r, field) {
      this.editMode = false;
      Vue.set(r, '_edit_' + field, false);
    },
    async saveRecord(r, field) {
      if (r.reserved) return;
      this.$emit('on-save', r, field);
    },
  },
};
</script>
